export enum LocaleLabels {
    English = 'en',
    French = 'fr',
    Deutsch = 'de',
    Nederlands = 'nl'
  }